import { FC } from 'react';

import { Stack, Typography } from '@mui/material';

import { NavGroupType } from '@src/types/main';

import NavItemMini from '../nav-item-mini';
import NavSubGroupMini from '../nav-sub-group-mini';

type NavGroupMiniProps = {
  group: NavGroupType;
};

const NavGroupMini: FC<NavGroupMiniProps> = (props) => {
  const { group } = props;

  return (
    <Stack
      gap={1}
      alignItems="center"
      justifyContent="center"
      sx={{ width: '100%' }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontSize: '14px',
          wordBreak: 'break-word',
          alignSelf: 'center',
          textAlign: 'center',
          width: 65,
        }}
      >
        {group.label}
      </Typography>
      <Stack gap={1}>
        {group.entries.map((entry) =>
          entry.type === 'subGroup' ? (
            <NavSubGroupMini key={entry.id} group={entry} />
          ) : (
            <NavItemMini key={entry.id} item={entry} />
          )
        )}
      </Stack>
    </Stack>
  );
};

export default NavGroupMini;
